import RISlider from 'react-input-slider'

function Slider({ ...otherProps }) {
  return <RISlider {...otherProps} />
}

export default Slider
